import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError, ok } from "@nju/result";
import { ResetPasswordResult } from "./types";

interface Props {
  email: string;
}
export async function resetPassword({
  email,
}: Props): Promise<ResetPasswordResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/users/passwordReset`,
    {
      method: "post",
      headers: {
        "Accept-Language": "pl",
        Cookie: "KEYCLOAK_LOCALE=pl",
        "Client-id": `${process.env.NEXT_PUBLIC_CLIENT_ID}`,
      },
      json: { email, brand: "NJU" },
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(undefined);
}
